// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1VMEV","data":"style_data__1shpe","item":"style_item__kK6Is","items":"style_items__3HAEx"};